import gatewayApi from "./gatewayAxios";

// POST /auth/reauth on the gateway: after the user's IP changed (gateway code GWB001) the SAME login
// token is re-bound to the new IP once the owner proves the MPIN. This is not merchant-portal-backend's
// validate-mpin (that one cannot re-bind anything). The path is outside gatewayApi's /api/bpay base,
// so the URL is absolute; the interceptors still add the session id, encrypt the body and attach the
// audit headers.
export async function reauthWithMpin({ mid, mpin, token }) {
  const res = await gatewayApi({
    method: "POST",
    url: `${process.env.REACT_APP_GATEWAY_URL}/auth/reauth`,
    data: { mid, mpin },
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return res.data;
}
